import * as THREE from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';
import { AsciiEffect } from 'three/examples/jsm/effects/AsciiEffect.js';

import model2 from 'url:../models/model2.stl';
import model3 from 'url:../models/model3.stl';
import model4 from 'url:../models/model4.stl';
import model5 from 'url:../models/model5.stl';
import model6 from 'url:../models/model6.stl';
import model7 from 'url:../models/model7.stl';
import model8 from 'url:../models/model8.stl';

const modelList = [model2, model3, model4, model5, model6, model7, model8];
const randomIndex = Math.floor(Math.random() * modelList.length);
const modelURL = modelList[randomIndex];

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(4.5, window.innerWidth / window.innerHeight, 1, 1000);
camera.position.set(0, 100, 0);
camera.lookAt(0, 0, 0);
camera.up.set(0, 0, 1);

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;
const asciiResolution = isMobile ? 0.25 : 0.2;

// Add extra padding to renderer size to prevent cutoff
const paddingFactor = 1.1; // 10% extra
const renderWidth = Math.ceil(window.innerWidth * paddingFactor);
const renderHeight = Math.ceil(window.innerHeight);

const renderer = new THREE.WebGLRenderer();
renderer.setSize(renderWidth, renderHeight);
renderer.setClearColor(0xFBFBF9);
renderer.localClippingEnabled = true;
document.body.appendChild(renderer.domElement);

const effect = new AsciiEffect(renderer, ' .:-=+*1#%@0$!*', { invert: false, resolution: asciiResolution});
effect.domElement.style.color = '#ADADAD';
effect.domElement.style.backgroundColor = '#ffffff';
effect.domElement.style.visibility = 'hidden';
effect.domElement.style.position = 'absolute';
effect.domElement.style.top = '50%';
effect.domElement.style.left = '50%';
effect.domElement.style.transform = 'translate(-50%, -50%)';
effect.setSize(renderWidth, renderHeight);

const asciiContainer = document.getElementById('ascii-container');
asciiContainer.style.position = 'relative';
asciiContainer.style.overflow = 'hidden';
asciiContainer.appendChild(effect.domElement);

const loader = new STLLoader();
let mesh;
let clippingPlane;
let modelHeight;
let growStartTime = null;
const growDuration = 1000;

loader.load(modelURL, (geometry) => {
  geometry.computeBoundingBox();
  const boundingBox = geometry.boundingBox;
  const offsetX = (boundingBox.max.x + boundingBox.min.x) / 2;
  const offsetY = (boundingBox.max.y + boundingBox.min.y) / 2;
  const height = boundingBox.max.z - boundingBox.min.z;
  const offsetZ = boundingBox.min.z + height / 1.7;

  geometry.translate(-offsetX, -offsetY, -offsetZ);
  
  geometry.computeBoundingBox();
  const newBounds = geometry.boundingBox;
  modelHeight = newBounds.max.z - newBounds.min.z;

  clippingPlane = new THREE.Plane(new THREE.Vector3(0, 0, 1), -newBounds.min.z);

  const material = new THREE.MeshNormalMaterial({
    clippingPlanes: [clippingPlane],
    clipShadows: true
  });
  
  mesh = new THREE.Mesh(geometry, material);
  mesh.rotation.set(Math.PI, 0, 0);

  scene.add(mesh);
  
  setTimeout(() => {
    effect.domElement.style.visibility = 'visible';
    growStartTime = Date.now();
  }, 300);
  
  animate();
});

function animate() {
  requestAnimationFrame(animate);
  
  if (mesh) {
    mesh.rotation.z += 0.002;
  }
  
  if (growStartTime && clippingPlane) {
    const elapsed = Date.now() - growStartTime;
    const progress = Math.min(elapsed / growDuration, 1);
    
    const currentHeight = mesh.geometry.boundingBox.min.z + (modelHeight * progress);
    clippingPlane.constant = currentHeight;
    
    if (progress >= 1) {
      growStartTime = null;
      mesh.material.clippingPlanes = [];
    }
  }
  
  effect.render(scene, camera);
}

window.addEventListener('resize', () => {
  const newRenderWidth = Math.ceil(window.innerWidth * paddingFactor);
  const newRenderHeight = Math.ceil(window.innerHeight * paddingFactor);
  
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(newRenderWidth, newRenderHeight);
  effect.setSize(newRenderWidth, newRenderHeight);
});